import React, { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';

let sheetLocks = 0;
const closeStack = [];

function onDocKey(e) {
  if (e.key !== 'Escape' || !closeStack.length) return;
  e.preventDefault();
  closeStack[closeStack.length - 1]();
}

function pushSheet(close) {
  if (closeStack.length === 0) document.addEventListener('keydown', onDocKey);
  closeStack.push(close);
  sheetLocks += 1;
  document.body.style.overflow = 'hidden';
}

function popSheet(close) {
  const i = closeStack.lastIndexOf(close);
  if (i >= 0) closeStack.splice(i, 1);
  if (closeStack.length === 0) document.removeEventListener('keydown', onDocKey);
  sheetLocks = Math.max(0, sheetLocks - 1);
  if (sheetLocks === 0) document.body.style.overflow = '';
}

export function Sheet({ title, sub, children, onClose, footer, tall = false }) {
  const onCloseRef = useRef(onClose);
  onCloseRef.current = onClose;

  useEffect(() => {
    const close = () => onCloseRef.current();
    pushSheet(close);
    return () => popSheet(close);
  }, []);

  if (typeof document === 'undefined') return null;

  return createPortal(
    <div
      className="sheet-back"
      onMouseDown={(e) => e.target === e.currentTarget && onClose()}
    >
      <div className={`sheet${tall ? ' tall' : ''}`} role="dialog" aria-modal="true">
        <div className="sheet-handle" aria-hidden="true" />
        {(title || onClose) && (
          <header className="sheet-head">
            <div className="sheet-head-copy">
              {title && <h3>{title}</h3>}
              {sub && <span className="sub dim tiny">{sub}</span>}
            </div>
            <button type="button" className="btn ghost sm" onClick={onClose} aria-label="Close">
              Close
            </button>
          </header>
        )}
        <div className="sheet-body">{children}</div>
        {footer && <footer className="sheet-foot">{footer}</footer>}
      </div>
    </div>,
    document.body,
  );
}
